<div class="host ___dashboard page" *ngIf="page$ | async as page; else loadingView">
  <div class="main" *ngIf="page.ok; else notFound">
  <ng-container *ngIf="data$ | async; let data">
  <ng-container *ngIf="!query ? data.pageItems : (data.searchItems || data.pageItems); let listingItems">
  <ng-container *ngIf="listingItems | userRoleFilter : role; let activeItems;">

    <div class="head">

      <div class="title">
        <h1>Users</h1>
      </div>

      <ul class="roles" *ngIf="listingItems | userExtractRoles as listingRoles">
        <ng-container *ngFor="let listingRole of listingRoles">
          <li *ngIf="listingRole.count">
            <strong *ngIf="listingRole.value === role; else inactive">{{ listingRole.title }}</strong>
            <ng-template #inactive>
              <a href="#" (click)="role=listingRole.value; false">{{ listingRole.title }}</a>
            </ng-template>
            <em *ngIf="listingRole.value === 'all'">({{ data.totalCount }})</em>
          </li>
        </ng-container>
      </ul>

    </div>

    <div class="body">
      
      <ng-template #listingBar>
        <div class="search">
          <input
            class="form-control"
            type="search"
            placeholder="Username or search query ..."
            [(ngModel)]="query"
            (keyup.enter)="search(data.searchQuery)"
          >
          <button class="button-primary" (click)="search(data.searchQuery)" [disabled]="!query">Search</button>
        </div>
        <div class="counter">{{ activeItems.length }} items</div>
      </ng-template>

      <div class="headbar">
        <ng-container *ngTemplateOutlet="listingBar"></ng-container>
      </div>

      <div class="major">

        <table class="listing table-striped">

          <thead>
            <tr>
              <th class="username">Name</th>
              <th class="role">Role</th>
              <th class="date">Date</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="isListingLoading">
              <td colspan="42">
                <div class="loading">
                  <nguix-dashboard-spinner></nguix-dashboard-spinner>
                </div>
              </td>
            </tr>
            <tr *ngIf="query && data.searchItems">
              <td colspan="42">Currently view top search result for query "<strong>{{ data.searchQuery }}</strong>", <a href="#" (click)="query=''; false;">clear search</a>.</td>
            </tr>
            <tr *ngFor="let listingItem of activeItems">
              <td class="username">
                <a href="#" (click)="detailItem=listingItem;false">
                  <strong>{{ listingItem.id }}</strong>
                </a>
              </td>
              <td class="role">{{ listingItem.role }}</td>
              <td class="date">{{ listingItem.createdAt | date }}</td>
            </tr>
          </tbody>

          <tfoot>
            <tr>
              <td colspan="42">
                <div class="tfoot">
                  <div class="left">
                    <button class="button-outline-medium-sm" (click)="previousPage()" [disabled]="(query && data.searchItems) || pageNo === 1">
                      <i class="icon-medium-tint icon-dashboard-left"></i>
                    </button>
                    <button class="button-outline-medium-sm" (click)="nextPage()" [disabled]="(query && data.searchItems) || data.totalPages === 1 || pageNo === data.totalPages">
                      <i class="icon-medium-tint icon-dashboard-right"></i>
                    </button>
                  </div>
                  <div class="right">
                    {{ (query && data.searchItems) ? '-/-' : (pageNo + '/' + data.totalPages) }} pages
                  </div>
                </div>
              </td>
            </tr>
          </tfoot>

        </table>

        <div class="detail" [class.show]="detailItem" *ngIf="detailItem">
          <div class="top">
            <div class="title">
              <strong>{{ detailItem.id }}</strong>
            </div>
            <a href="#" (click)="detailItem=undefined;false;">X</a>
          </div>
          <div class="content">
            <div class="image">
              <img [src]="(detailItem.thumbnails?.md || detailItem.thumbnails?.default)?.src" [alt]="detailItem.id">
            </div>
            <div class="username">
              <span>Username</span>
              <strong>
                <a href="#" target="_blank">{{ detailItem.id }}</a>
              </strong>
            </div>
            <div class="name">
              <span>Name</span>
              <strong>{{ detailItem.title }}</strong>
            </div>
            <div class="status">
              <span>Status</span>
              <strong>{{ detailItem.status === 'publish' ? 'Public' : 'Private' }}</strong>
            </div>
            <div class="role">
              <span>Role</span>
              <strong>{{ detailItem.role }}</strong>
            </div>
            <div class="rank" *ngIf="detailItem.rank">
              <span>Rank</span>
              <strong>{{ detailItem.rank }}</strong>
            </div>
            <div class="legit" *ngIf="detailItem.legit">
              <span>Legit</span>
              <strong>{{ detailItem.legit }}</strong>
            </div>
            <div class="created">
              <span>Created</span>
              <strong>{{ detailItem.createdAt | date }}</strong>
            </div>
            <div class="updated">
              <span>Updated</span>
              <strong>{{ detailItem.updatedAt | date }}</strong>
            </div>
            <div class="actions">
              <a
                class="button-primary-sm"
                [usefulRouterLink]="['app-dashboard', 'edit', 'profile', detailItem.id]"
              >Edit</a>
            </div>
          </div>
        </div>

      </div>
      
      <div class="footbar">
        <ng-container *ngTemplateOutlet="listingBar"></ng-container>
      </div>

    </div>

  </ng-container>
  </ng-container>
  </ng-container>
  </div>

  <ng-template #notFound>
    <div class="not-found">Not found ...</div>
  </ng-template>

</div>

<ng-template #loadingView>
  <div class="loading">
    <nguix-dashboard-spinner></nguix-dashboard-spinner>
  </div>
</ng-template>
